//Suites 1 recamara

//LoftSuite
import image1 from "../../assets/Suites/Suites 1 Recamara/LoftSuite/LoftSuite-1.webp"
import image2 from "../../assets/Suites/Suites 1 Recamara/LoftSuite/LoftSuite-2.webp"
import image3 from "../../assets/Suites/Suites 1 Recamara/LoftSuite/LoftSuite-3.webp"
import image4 from "../../assets/Suites/Suites 1 Recamara/LoftSuite/LoftSuite-4.webp"
import image5 from "../../assets/Suites/Suites 1 Recamara/LoftSuite/LoftSuite-5.webp"
import image6 from "../../assets/Suites/Suites 1 Recamara/LoftSuite/LoftSuite-6.webp"
import image7 from "../../assets/Suites/Suites 1 Recamara/LoftSuite/LoftSuite-7.webp"

const LoftSuite = {
    "images":[
        {
        "original":image1,
        "thumbnail":image1
        },
        {
        "original":image2,
        "thumbnail":image2
        },
        {
        "original":image3,
        "thumbnail":image3
        },
        {
        "original":image4,
        "thumbnail":image4
        },
        {
        "original":image5,
        "thumbnail":image5
        },
        {
        "original":image6,
        "thumbnail":image6
        },
        {
        "original":image7,
        "thumbnail":image7
        }
    ] 
}

export default LoftSuite;